import { z } from 'zod'

/**
 * Creates a zod string schema for a name field with:
 * - trim
 * - min 1, max 100 characters
 * - optional regex validation (only applied when regex is provided)
 *
 * @param fieldName - Used in error messages (e.g. 'Assessment type name', 'User base name')
 * @param regex - Optional. When provided, validates the string matches this pattern
 */
export const nameField = (
  fieldName: string,
  minLength: number = 1,
  maxLength: number = 100,
  regex?: RegExp,
  regexMessage?: string
) => {
  let schema = z
    .string()
    .trim()
    .min(minLength, `${fieldName} is required`)
    .max(maxLength, `${fieldName} must be less than ${maxLength} characters`)

  if (regex) schema = schema.regex(regex, regexMessage ?? `${fieldName} must be valid`)

  return schema
}
